import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import {
/* eslint-disable-next-line no-restricted-imports */
useAnalyticsEvents as useAKAnalyticsEvents,
/* eslint-disable-next-line no-restricted-imports */
withAnalyticsEvents as withAKAnalyticsEvents } from '@atlaskit/analytics-next';
import React from 'react';
// for class based components
export function withAnalytics(BaseComponent) {
  function HOCComponent(props) {
    const fireAnalyticsEvent = prop => {
      return (payload, channel = 'marketplace') => prop.createAnalyticsEvent(_objectSpread({}, payload)).fire(channel);
    };

    return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, props, {
      fireAnalyticsEvent: fireAnalyticsEvent(props)
    }));
  }

  return withAKAnalyticsEvents()(HOCComponent);
} // for functional components

export const useAnalyticsEvents = () => {
  const {
    createAnalyticsEvent
  } = useAKAnalyticsEvents();

  const handleAnalyticsEvent = (payload, channel = 'marketplace') => {
    createAnalyticsEvent(_objectSpread({}, payload)).fire(channel);
  };

  return handleAnalyticsEvent;
};